import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import * as Styled from './styled';

function SystemWideAlertList({ systemWideAlerts }) {
  return (
    <Styled.AlertListBody>
      {systemWideAlerts.map(a => (
        <Styled.AlertRow key={a.id} type={a.system_wide_message.type}>
          <Styled.AlertIconRow>
            <Styled.AlertIcon type={a.system_wide_message.type} />
          </Styled.AlertIconRow>
          <Styled.AlertHeader>{a.header_text}</Styled.AlertHeader>
          <Styled.AlertBody>
            {a.desc}
            {a.info_link_url != null && (
              <Styled.AlertMoreLink
                href={a.info_link_url}
                type={a.system_wide_message.type}
              >
                <FormattedMessage id="alerts.more" />
              </Styled.AlertMoreLink>
            )}
          </Styled.AlertBody>
        </Styled.AlertRow>
      ))}
    </Styled.AlertListBody>
  );
}

SystemWideAlertList.propTypes = {
  /** Collection of system wide alerts to display */
  systemWideAlerts: PropTypes.arrayOf(PropTypes.shape({}).isRequired)
    .isRequired,
};

export default SystemWideAlertList;
